import type { RhinoConfigInput } from '@rhino-project/core/config';
import { ReporterModelFilter } from './components/report/ReporterModelFilter';

const playerModelPaths = ['last_name', 'first_name'];

const rhinoConfig = {
  version: 1,
  appName: 'ESPM',
  authLogo: 'images/logo-dark.svg',
  components: {
    // Filters render inline on desktop and as the compact bar + bottom
    // sheet on mobile, everywhere
    ModelFilters: {
      props: { variant: 'responsive' }
    },
    event: {
      ModelFilters: {
        props: { paths: ['player.player_positions.position::tree_subtree'] }
      },
      ModelIndexActions: null,
      ModelIndexTable: {
        props: {
          paths: [
            'player.display_name',
            'name',
            'summary',
            'initiator.display_name'
          ],
          columnConfig: {
            'player.display_name': { width: 2 },
            name: { width: 2 },
            summary: { width: 3, hideBelow: 'sm' },
            'initiator.display_name': { width: 2, hideBelow: 'md' }
          }
        }
      }
    },
    lineup: {
      ModelCreateModal: {
        props: {
          paths: ['name', 'event_at']
        }
      },
      ModelEditModal: {
        props: {
          paths: ['name', 'event_at']
        }
      }
    },
    message: {
      ModelIndexTable: {
        props: {
          paths: [
            'message_type',
            'player.display_name',
            'created_at',
            'from.display_name',
            'player.current_roster.team_season.season.display_name',
            'player.current_roster.roster_status.display_name'
          ],
          columnConfig: {
            message_type: { width: 2 },
            'player.display_name': { width: 2 },
            created_at: { width: 1.5, hideBelow: 'sm' },
            'from.display_name': { width: 2, hideBelow: 'md' },
            'player.current_roster.team_season.season.display_name': {
              width: 1.5,
              hideBelow: 'lg'
            },
            'player.current_roster.roster_status.display_name': {
              width: 1.5,
              hideBelow: 'lg'
            }
          }
        }
      }
    },
    player: {
      ModelCreateModal: {
        props: {
          paths: playerModelPaths
        }
      },
      // A coach edits a player by name first and measurements last. The
      // fallback list is every updatable property in the order the resource
      // declares them, which reads alphabetically here. This names the same
      // fields in the order the screen wants them, so a property added to
      // Player has to be added here too before it appears on this form.
      ModelEditForm: {
        props: {
          paths: [
            'first_name',
            'last_name',
            'dob_year',
            'grad_year',
            'hand',
            'number',
            'hometown',
            'country',
            'height_feet',
            'height_inches',
            'weight_lbs',
            'player_positions',
            'rosters',
            'current_roster',
            'external_linked_teams'
          ]
        }
      }
    },
    report: {
      ModelFilters: {
        props: {
          paths: [
            'report_type',
            <ReporterModelFilter key="reporter" path="reporter" />,
            'player.player_positions.position::tree_subtree'
          ]
        }
      },
      ModelIndexActions: null,
      ModelIndexTable: {
        props: {
          paths: [
            'report_type.name',
            'player.display_name',
            'reported_at',
            'reporter.display_name',
            'player.current_roster.team_season.season.display_name',
            'player.current_roster.roster_status.display_name'
          ],
          columnConfig: {
            'report_type.name': { width: 2 },
            'player.display_name': { width: 2 },
            reported_at: { width: 1.5, hideBelow: 'sm' },
            'reporter.display_name': { width: 2, hideBelow: 'md' },
            'player.current_roster.team_season.season.display_name': {
              width: 1.5,
              hideBelow: 'lg'
            },
            'player.current_roster.roster_status.display_name': {
              width: 1.5,
              hideBelow: 'lg'
            }
          }
        }
      }
    },
    video: {
      ModelIndexTable: {
        props: { paths: ['title', 'category', 'scheduled_at', 'system'] }
      },
      ModelCreateModal: {
        props: {
          paths: [
            'title',
            'url',
            'category',
            'scheduled_at',
            'system',
            'description'
          ]
        }
      }
    },
    practice_plan: {
      ModelIndexTable: {
        props: { paths: ['title', 'plan_date'] }
      },
      ModelCreateModal: {
        props: { paths: ['title', 'plan_date', 'pdf', 'description'] }
      }
    }
  }
} satisfies RhinoConfigInput;

export default rhinoConfig;
